import React from 'react';
import lodash from 'lodash';

export const convertArrToObj = (
  array,
  key,
  manipulator = false,
  getKeyManipulated = false,
) => {
  const initialValue = {};
  if (!array.length) return initialValue;
  return array.reduce((obj, item) => {
    const itemManipulated = !manipulator ? item : manipulator(item);
    const newKey = getKeyManipulated ? itemManipulated[key] : item[key];
    return {
      ...obj,
      [newKey]: itemManipulated,
    };
  }, initialValue);
};

export const convertObjToArr = obj => {
  const arrKeys = Object.keys(obj);
  if (!arrKeys.length) return [];
  return arrKeys.map(itemKey => obj[itemKey]);
};

export const mergeArraysKey = (
  objSource,
  arrDest,
  objSourceKey,
  arrDestKey,
  defaultValue,
) => {
  const arrayMerged = [];
  arrDest.map(item =>
    arrayMerged.push({
      ...item,
      moduleName: item[arrDestKey]
        ? objSource[item[arrDestKey]][objSourceKey]
        : defaultValue,
    }),
  );
  return arrayMerged;
};

export const sortArrByKey = (array, keySort, reverse = false) => {
  const sortedArr = lodash.sortBy(array, keySort);
  return reverse ? lodash.reverse(sortedArr) : sortedArr;
};

export const paginateArr = (array, pageSize, pageNumber) =>
  array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);

export const normalizeNumber = (value, padding) => {
  const zeroes = new Array(padding + 1).join('0');
  return (zeroes + value).slice(-padding);
};

export const usePrevious = value => {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useScript = (text, listen) => {
  React.useEffect(() => {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.innerHTML = `document.write('${text}')`;
    document.body.appendChild(s);
  }, [text, listen]);
};

export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
